<ng-container *transloco="let t;">
<div class="auth-wrapper auth-v2">
    <div class="auth-inner">
      <!-- Login -->
      <div class="auth-bg px-2 p-lg-5 w-100 full-height">
        <!-- Brand logo-->
        <a class="brand-logo mb-25" href="javascript:void(0);">
          <img src="{{ coreConfig.app.appLogoImage }}" alt="brand-logo-crm" height="28" />
          <h2 class="brand-text text-primary ms-1">SimpleSign</h2>
        </a>
        <!-- /Brand logo-->
        <p class="card-text mb-1 d-flex justify-content-center">To use the integration, log in to your existing SimpleSign account or create a new one</p>
        <div class="row justify-content-center mt-3">
          <div class="col-12 col-sm-8 col-md-6 col-lg-5 px-2 py-25 bg-white crm-form-container">          
           <ngb-alert [type]="'danger'" [dismissible]="false" *ngIf="error">
              <div class="alert-body">
                <p>{{ error }}</p>
              </div>
            </ngb-alert>
            <form class="auth-login-form mt-1" [formGroup]="loginForm" (ngSubmit)="onLogin()">
              <div class="form-group">
                <label class="form-label" for="login-email">Email</label>
                <input
                  type="text"
                  formControlName="email"
                  class="form-control"
                  [ngClass]="{ 'is-invalid': submitted && form.email.errors }"
                  placeholder="Email"
                  aria-describedby="login-email"
                  autofocus=""
                  tabindex="1"
                />
                <div *ngIf="submitted && form.email.errors" class="invalid-feedback">
                  <div *ngIf="form.email.errors.required">Email is required</div>
                  <div *ngIf="form.email.errors.email">Email must be a valid email address</div>
                </div>
              </div>
              <div class="form-group">
                <div class="d-flex justify-content-between">
                  <label for="login-password">Password</label>
                  <a routerLink="/forgot-password-v2"><small>Forgot Password?</small></a>
                </div>
                <div class="input-group input-group-merge form-password-toggle">
                  <input
                    [type]="passwordTextType ? 'text' : 'password'"
                    formControlName="password"
                    class="form-control form-control-merge"
                    [ngClass]="{ 'is-invalid error': submitted && form.password.errors }"
                    placeholder="············"
                    aria-describedby="login-password"
                    tabindex="2"
                  />
                  <div class="input-group-append">
                    <span class="input-group-text cursor-pointer">
                      <i
                        class="feather font-small-4"
                        [ngClass]="{
                          'icon-eye-off': passwordTextType,
                          'icon-eye': !passwordTextType
                        }"
                        (click)="togglePasswordTextType()"
                      ></i>
                    </span>
                  </div>
                </div>
                <div
                  *ngIf="submitted && form.password.errors"
                  class="invalid-feedback"
                  [ngClass]="{ 'd-block': submitted && form.password.errors }"
                >
                  <div *ngIf="form.password.errors.required">Password is required</div>
                </div>
              </div>
              <div class="form-group">
                <div class="custom-control custom-checkbox">
                  <input class="custom-control-input" id="remember-me" type="checkbox" tabindex="3" />
                  <label class="custom-control-label" for="remember-me"> Remember Me</label>
                </div>
              </div>
              <button [disabled]="authFormLoader$ | async" class="btn btn-primary btn-block" tabindex="4" rippleEffect>
                <span *ngIf="authFormLoader$ | async" class="spinner-border spinner-border-sm me-1"></span>Sign in
              </button>
            </form>
            <div class="divider my-2">
              <div class="divider-text">{{t('Or text (general) - or')}}</div>
            </div>
            <div class="auth-footer-btn d-flex justify-content-center mb-2">
                <app-social-logins-links></app-social-logins-links>
            </div>
          </div>
          <div class="col-12 col-sm-8 col-md-6 col-lg-4 d-flex justify-content-start align-items-center p-0">
            <div class="crm-signup-wrapper w-100">
              <p class="text-center mt-0 font-medium-3 font-weight-600">
                <span>Don't have a Simplesign account?</span>
              </p>
              <button routerLink="/register" class="btn btn-success btn-block" rippleEffect>
                Create an account
              </button>
            </div>
          </div>

        </div>
      </div>
      <!-- /Login -->
    </div>
  </div>
</ng-container>
  